import * as React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import "../style/Variable.css";

export default function ListEditor(props) {
    const { variableDefault, changeDefault, variableId } = props;

    const [lines, setLines] = React.useState(() => {
        if (typeof variableDefault !== 'string') {
        changeDefault(variableId, '');
        return '';
        }
        return variableDefault.split('\n');
    });

    // Update the state when the 'variableDefault' prop changes
    React.useEffect(() => {
        if (typeof variableDefault !== 'string') {
        changeDefault(variableId, '');
        } else {
        setLines(variableDefault.split('\n'));
        }
    }, [variableDefault, changeDefault, variableId]);

    const handleTextChange = (event, index) => {
        const newLines = [...lines];
        newLines[index] = event.target.value;
        setLines(newLines);
        changeDefault(variableId, newLines.join('\n'));
    };

    const handleAddTextField = (index) => {
        const newLines = [...lines.slice(0, index + 1), '', ...lines.slice(index + 1)];
        setLines(newLines);
        changeDefault(variableId, newLines.join('\n'));
    };

    const handleRemoveTextField = (index) => {
        const newLines = [...lines.slice(0, index), ...lines.slice(index + 1)];
        setLines(newLines);
        changeDefault(variableId, newLines.join('\n'));
    };

    return (
        <div>
        {lines.map((line, index) => (
            <div key={`line-wrapper-${variableId}-${index}`} style={{ display: 'flex', alignItems: 'flex-end', marginBottom: 15 }}>
                <TextField
                    key={`default-item-${variableId}-${index}`}
                    size="small"
                    className="Text_Editor"
                    label={`Item ${index + 1} Default`}
                    value={line}
                    onChange={(event) => handleTextChange(event, index)}
                    style={{ marginRight: 15 }}
                ></TextField>
                <div>
                    <Button color="success" onClick={() => handleAddTextField(index)} style={{ marginRight: 5, padding: '6px 8px', minWidth: 'auto' }}>
                        <FontAwesomeIcon icon={faPlus} size="lg" />
                    </Button>
                    <Button color="error" onClick={() => handleRemoveTextField(index)} disabled={lines.length <= 1} style={{ padding: '6px 8px', minWidth: 'auto' }}>
                        <FontAwesomeIcon icon={faXmark} size="lg" />
                    </Button>
                </div>
            </div>
        ))}
        </div>
    );
}


